import { configureStore } from "@reduxjs/toolkit";
import userReducer from "entities/user/model/slice";
import personalCabinetSlice from "entities/viewer/model/slice";
import marathonReducer from "entities/admin/model/slice";
import organizaionsReducer from "shared/queries/organization/slices";
import users2Reducer from "entities/admin/model/slice/usersSlice";
import marathonsReducer from "../../api/slice/marathonsSlice/marathonsSlice";
import users3Reducer from "api/slice/usersSlice/usersSlice";
import vouchersReducer from "../../api/slice/vouchersSlice/vouchersSlice";
import offerAgreementsReducer from "../../api/slice/offerAgreementsSlice/offerAgreementsSlice";
import applicationsReducer from "../../api/slice/applicationsSlice/applicationsSlice";
import corporateClientsReducer from "../../api/slice/corporateClientsSlice/corporateClientsSlice";
import productsReducer from "../../api/slice/productsSlice/productsSlice";
import promocodesReducer from "../../api/slice/promoCodesSlice/promoCodesSlice";
import cloudStorageReducer from "../../api/slice/cloudStorageSlice/cloudStorageSlice";
import productsCategoriesReducer from "../../api/slice/productCategoriesSlice/productCategoriesSlice";
import auditDocumentsReducer from "../../api/slice/auditDocumentsSlice/auditDocumentsSlice";
import marathonParticipantImagesReducer from "../../api/slice/marathonParticipantImagesSlice/marathonParticipantImagesSlice";
import { rootApi } from "app/rootApi";
import { useDispatch } from "react-redux";

const store = configureStore({
  reducer: {
    users: userReducer,
    personalCabinet: personalCabinetSlice,
    marathon: marathonReducer,
    organizations: organizaionsReducer,
    users2: users2Reducer,
    users3: users3Reducer,
    offerAgreements: offerAgreementsReducer,
    marathons: marathonsReducer,
    vouchers: vouchersReducer,
    applications: applicationsReducer,
    corporateClients: corporateClientsReducer,
    products: productsReducer,
    promocodes: promocodesReducer,
    cloudStorage: cloudStorageReducer,
    productsCategories: productsCategoriesReducer,
    auditDocuments: auditDocumentsReducer,
    marathonParticipantImages: marathonParticipantImagesReducer,
    [rootApi.reducerPath]: rootApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(rootApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export default store;
